/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  ImagesControllerCreateMutationRequest,
  ImagesControllerCreateMutationResponse,
  ImagesControllerCreate401,
} from '../../types/ImagesControllerCreate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { imagesCreate } from '../../methods/imagesCreate.ts';
import { useMutation } from '@tanstack/react-query';

export const imagesCreateMutationKey = () => [{ url: '/api/images' }] as const;

export type ImagesCreateMutationKey = ReturnType<typeof imagesCreateMutationKey>;

/**
 * {@link /api/images}
 */
export function useImagesCreate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ImagesControllerCreateMutationResponse,
      ResponseErrorConfig<ImagesControllerCreate401>,
      { data: ImagesControllerCreateMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<ImagesControllerCreateMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? imagesCreateMutationKey();

  return useMutation<
    ImagesControllerCreateMutationResponse,
    ResponseErrorConfig<ImagesControllerCreate401>,
    { data: ImagesControllerCreateMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return imagesCreate(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
